import React from "react"
import { Helmet } from "react-helmet"

const Badges = () => {
  return (
    <>
      <Helmet>
        {/* sourceForge */}
        <script
          async="true"
          src="https://b.sf-syn.com/badge_js?sf_id=3855075&variant_id=sf"
        ></script>

        {/* slashdot */}
        <script
          async="true"
          src="https://b.sf-syn.com/badge_js?sf_id=3855075&variant_id=sd"
        ></script>

        {/* goodfirms */}
        <script
          type="text/javascript"
          src="https://assets.goodfirms.co/assets/js/widget.min.js"
        ></script>

        {/* trustpilot */}
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>

        {/* top business software */}
        <script
          async="true"
          src="https://b.sf-syn.com/badge_js?sf_id=3855075&variant_id=tbs"
        ></script>
      </Helmet>

      {/* SourceForge Badges */}
      <div className="badge-link">
        <div
          className="sf-root"
          data-id="3855075"
          data-badge="light-default"
          data-variant-id="sf"
          style={{ width: "45%" }}
        >
          <a
            href="https://sourceforge.net/software/product/Panacea-Blood-Bank/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Panacea Reviews
          </a>
        </div>
      </div>

      <div className="badge-link">
        <div
          class="sf-root"
          data-id="3855075"
          data-badge="top-performer-spring-white"
          data-variant-id="sf"
          data-metadata="achievement=top-performer-seasonal-2025-spring"
          style={{ width: "53%" }}
        >
          <a
            href="https://sourceforge.net/software/product/Panacea-Blood-Bank/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Panacea Reviews
          </a>
        </div>
      </div>

      {/* top business software */}
      <div className="badge-link">
        <div
          class="sf-root"
          data-id="3855075"
          data-badge="high-achiever-spring"
          data-variant-id="tbs"
          data-metadata="achievement=top-performer-seasonal-2025-spring"
          style={{ width: "50%" }}
        >
          <a
            href="https://topbusinesssoftware.com/products/Panacea-Blood-Bank/reviews/"
            target="_blank"
          >
            Panacea Reviews
          </a>
        </div>
      </div>

      {/* Top Firms Badges */}
      <div className="badge-link">
        <div>
          <a
            href="https://topfirms.co/companies/software-development/usa"
            target="_blank"
          >
            <img
              width="60%"
              src="https://topfirms.co/wp-content/uploads/2020/03/software-development-companies-round-badge.png"
              alt="eCommerce Development Companies"
            />
          </a>
        </div>
      </div>

      <div className="badge-link">
        <div>
          <a
            href="https://topfirms.co/companies/web-development/australia"
            target="_blank"
          >
            <img
              width="75%"
              src="https://topfirms.co/wp-content/uploads/2019/10/top-web-development-company-badge-square.jpg"
              alt="eCommerce Development Companies"
            />
          </a>
        </div>
      </div>

      {/* slashdot badge */}
      <div className="badge-link">
        <div
          className="sf-root"
          data-id="3855075"
          data-badge="users-love-us-new-white"
          data-variant-id="sd"
          style={{ width: "45%" }}
        >
          <a
            href="https://slashdot.org/software/p/Panacea-Blood-Bank/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Panacea Reviews
          </a>
        </div>
      </div>
      <div className="badge-link">
        <div
          class="sf-root"
          data-id="3855075"
          data-badge="trusted-vendor-black"
          data-variant-id="sd"
          style={{ width: "80%" }}
        >
          <a
            href="https://slashdot.org/software/p/Panacea-Blood-Bank/"
            target="_blank"
          >
            Panacea Reviews
          </a>
        </div>
      </div>

      {/* GoodFirms Badge */}
      <div className="badge-link">
        <div
          className="goodfirm-widget"
          data-widget-type="goodfirms-widget-t8"
          data-widget-pattern="poweredby-star"
          data-height="100"
          data-company-id="141674"
        ></div>
      </div>

      {/* TrustPilot Badge */}
      <div className="badge-link">
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="56278e9abfbbba0bdcd568bc"
          data-businessunit-id="652761e1455122d8766ea49a"
          data-style-height="52px"
          data-style-width="100%"
        >
          <a
            href="https://www.trustpilot.com/review/zaavia.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </>
  )
}

export default Badges
